// removed by extract-text-webpack-plugin
module.exports = {"searchHighlight":"_1-1bXdB6MRtHz-dJQDdBZJ_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-style-loader!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/style-compiler?{"id":"data-v-b2fc2b56","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/ShowReturns.vue
// module id = 1025
// module chunks = 1